import React, { useEffect, useState } from 'react';
import './SolutionsFunnelGraphic.css';

const STAGES = [
  {
    id: 'findings',
    meta: '01 · FINDINGS',
    stat: '60k',
    iconSrc: '/images/solutions/workflow-risk-reduction-01-findings.svg',
  },
  {
    id: 'insights',
    meta: '02 · INSIGHTS',
    stat: '10k',
    iconSrc: '/images/solutions/workflow-risk-reduction-02-insights.svg',
  },
  {
    id: 'verified',
    meta: '03 · VERIFIED',
    stat: '3k',
    iconSrc: '/images/solutions/workflow-risk-reduction-03-verified.svg',
  },
  {
    id: 'prioritized',
    meta: '04 · PRIORITIZED',
    stat: '1k',
    iconSrc: '/images/solutions/workflow-risk-reduction-04-prioritized.svg',
  },
  {
    id: 'remediated',
    meta: '05 · REMEDIATED',
    stat: '100%',
    iconSrc: '/images/solutions/workflow-risk-reduction-05-remediated.svg',
  },
];

const STEP_MS = 2800;

const SolutionsFunnelGraphic = ({
  titleId = 'solutions-funnel-heading',
  theme = 'dark',
  showEyebrow = true,
  showTitle = true,
  titleText = 'From findings to remediated',
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [reduceMotion, setReduceMotion] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const sync = () => setReduceMotion(mq.matches);
    sync();
    mq.addEventListener('change', sync);
    return () => mq.removeEventListener('change', sync);
  }, []);

  useEffect(() => {
    if (reduceMotion) return undefined;
    const id = window.setInterval(() => {
      setActiveIndex((i) => (i + 1) % STAGES.length);
    }, STEP_MS);
    return () => window.clearInterval(id);
  }, [reduceMotion]);

  const lastIndex = STAGES.length - 1;
  const progress = reduceMotion ? 1 : lastIndex === 0 ? 0 : activeIndex / lastIndex;

  return (
    <div
      className={`solutions-funnel solutions-funnel--${theme}${
        reduceMotion ? ' solutions-funnel--reduce-motion' : ''
      }`}
    >
      {showEyebrow ? <p className="solutions-stepper__eyebrow">Risk reduction</p> : null}
      {showTitle ? (
        <h2 id={titleId} className="solutions-stepper__title">
          {titleText}
        </h2>
      ) : null}

      <div className="solutions-funnel__scroll">
        <div className="solutions-funnel__frame">
          <div className="solutions-funnel__rail" aria-hidden="true">
            <div className="solutions-funnel__rail-bg" />
            <div
              className="solutions-funnel__rail-fill"
              style={{ '--funnel-progress': String(progress) }}
            />
          </div>
          <ol className="solutions-funnel__steps">
            {STAGES.map((stage, i) => {
              let state = 'upcoming';
              if (reduceMotion) {
                state = 'complete';
              } else if (i < activeIndex) {
                state = 'complete';
              } else if (i === activeIndex) {
                state = 'active';
              }
              return (
                <li
                  key={stage.id}
                  className={`solutions-funnel__step solutions-funnel__step--${state}`}
                  aria-current={!reduceMotion && i === activeIndex ? 'step' : undefined}
                  aria-label={`${stage.stat}, ${stage.meta}`}
                >
                  <span className="solutions-funnel__node-wrap">
                    <span className="solutions-funnel__node">
                      <img
                        src={stage.iconSrc}
                        alt=""
                        width={48}
                        height={48}
                        loading="lazy"
                        decoding="async"
                      />
                    </span>
                  </span>
                  <span className="solutions-funnel__stat">{stage.stat}</span>
                  <span className="solutions-funnel__meta">{stage.meta}</span>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </div>
  );
};

export default SolutionsFunnelGraphic;
